import PropTypes from "prop-types";
import slugify from "slugify";
import Link from "next/link";
import Button from "components/shared/button/Button";
import CategoryHeader from "components/helpdesk/categoryHeader/CategoryHeader";
import {
    CategoriesDesktop,
    OffscreenTitle,
    Item,
    Questions,
    Question,
    StyledLink
} from "./Desktop.styled";

export default function Desktop({ categoriesFaq }) {
    return (
        <CategoriesDesktop>
            <OffscreenTitle>Categorieën</OffscreenTitle>
            {categoriesFaq.map(category => {
                const slugifiedName = slugify(category.name, {
                    lower: true
                });

                return (
                    (category?.articles?.length > 0 ||
                        category?.mostpopular?.length > 0) && (
                        <Item key={category.name}>
                            <CategoryHeader
                                categorySlug={slugifiedName}
                                title={category.name}
                            />
                            <Questions>
                                {category.mostpopular?.map(popularQuestion => (
                                    <Question key={popularQuestion.name}>
                                        <Link
                                            href={`/helpdesk/[category]?question=${slugify(
                                                popularQuestion.name,
                                                { lower: true }
                                            )}`}
                                            as={`/helpdesk/${slugifiedName}?question=${slugify(
                                                popularQuestion.name,
                                                { lower: true }
                                            )}`}
                                            passHref
                                        >
                                            <StyledLink>
                                                {popularQuestion.name}
                                            </StyledLink>
                                        </Link>
                                    </Question>
                                ))}
                            </Questions>
                            <Link
                                href="/helpdesk/[category]"
                                as={`/helpdesk/${slugifiedName}`}
                                passHref
                            >
                                <Button element="a" variant="ghost">
                                    Bekijk meer vragen
                                </Button>
                            </Link>
                        </Item>
                    )
                );
            })}
        </CategoriesDesktop>
    );
}

Desktop.propTypes = {
    categoriesFaq: PropTypes.arrayOf(PropTypes.object).isRequired
};
